<template>
  <Modal max-width="520" title="Deseja excluir esse site?" title-section-mobile="Deseja excluir esse site?" controlsDirection="right">
    <form @submit.prevent.stop="$emit('removerPorId')">
      <p class="text-caption">Deseja realmente excluir o site <b>{{dataFiltered.domain}}?</b></p>
      <p class="text-caption">Para prosseguir com a exclusão, digite o seu site no campo abaixo:</p>
      <div class="mt-4">
        <TextField placeholder="Digite o domínio para prosseguir" v-model="domain" required type="text" tooltipPosition="right" />
      </div>
      <div class="d-flex justify-end mt-4" style="gap:8px">
        <Button color="primary" label="Talvez outra hora" text @click="toggleModal"/>
        <Button v-bind="buttonProps" label="Excluir site" type="submit" color="primary" @click="siteDelete" :disabled="disabledButton"/>
      </div>
    </form>
  </Modal>
</template>

<script>
import { Button, Modal, TextField } from '@locaweb/design-system-vue'
import { deleteSite } from '@/views/site/api/site.api'

export default {
  components: { Button, Modal, TextField },
  props: ['filteredData', 'idSite'],
  data () {
    return {
      domain: null,
      statusDelete: false
    }
  },
  methods: {
    async siteDelete () {
      try {
        this.statusDelete = true
        const idNumber = Number(this.idSite)
        const deleteStatus = await deleteSite(idNumber)
        console.log('deleteStatus.status', deleteStatus.status)
        if (deleteStatus.status === 200) {
          this.statusDelete = false
          this.$emit('closeModal')
        }
      } catch (error) {
        console.error(error)
      }
    },
    toggleModal () {
      this.$emit('closeCancel')
    }
  },
  computed: {
    dataFiltered () {
      const idNumber = Number(this.idSite)
      const data = this.filteredData.filter((item) => item.id === idNumber)
      return data[0]
    },
    disabledButton () {
      return !this.domain || this.domain !== this.dataFiltered.domain
    },
    buttonProps () {
      let status = { loading: false }
      if (this.statusDelete) {
        status = { loading: true }
      }
      return status
    }
  }
}
</script>
